export type ISMSController = ReturnType<typeof SMSControllerFactory>;

export const SMSControllerFactory = ({
  smsService,
}: {
  smsService: ISMSService;
}) => {
  const sendOTP = async (payload: { phone_number: string }) => {
    return await smsService.sendOTP(payload);
  };

  const verifyOTP = async (payload: {
    uniqueRequestId: string;
    otp: string;
  }) => {
    return await smsService.verifyOTP(payload);
  };

  const savePhoneNumber = async (payload: { phone_number: string }) => {
    return await smsService.savePhoneNumber(payload);
  };

  const getPhoneNumber = async () => {
    return await smsService.getPhoneNumber();
  };

  return {
    sendOTP,
    verifyOTP,
    savePhoneNumber,
    getPhoneNumber,
  };
};
